import { Card, Pane, Avatar, Text, Badge } from 'evergreen-ui';
import React from 'react';
import useIsAdmin from 'src/hooks/useIsAdmin';

const UserCard = () => {
  const { user, isAdmin } = useIsAdmin();

  if (!user) {
    return <React.Fragment />;
  }

  return (
    <Card width="100%" elevation={1} display="flex" flexDirection="column" gap="12px" padding="16px" marginTop="12px" marginBottom="12px">
      <Pane>{!isAdmin ? <Badge color="neutral">User</Badge> : <Badge color="green">Admin</Badge>}</Pane>
      <Pane display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" gap="8px">
        <Avatar name={user.displayName} src={user.photoURL} size={40} />
        <Text>{user.displayName}</Text>
      </Pane>
    </Card>
  );
};

export default UserCard;
